module.exports = __webpack_public_path__ + "static/media/edit.a26f4ca1.svg";